import { Box, Stack, Typography } from '@mui/material'
import React from 'react'
import SettingsSelection from '../settings-selection/settings-selection.component'
import { useDispatch, useSelector } from 'react-redux'
import { RootState } from '../../../store'
import ArrowLeft from '../../../assets/icons/ArrowLeft.png'
import SettingsDetails from '../settings-details/settings-details.component'
import { clearMobileTabIndex } from '../../../store/company/company.slice'

const SettingsMobileSelection = () => {
  const dispatch = useDispatch()

  const mobileTabIndex = useSelector(
    (state: RootState) => state.company.mobileTabIndex
  )

  return typeof mobileTabIndex === 'number' ? (
    <Box p={2}>
      <Stack spacing={1}>
        <Stack
          direction="row"
          sx={{ cursor: 'pointer', alignItems: 'center' }}
          onClick={() => dispatch(clearMobileTabIndex())}
        >
          <Box px={1} pt={1}>
            <img src={ArrowLeft} alt="arrow left" width={24} height={24} />
          </Box>
          <Typography>Go Back</Typography>
        </Stack>
        <SettingsDetails />
      </Stack>
    </Box>
  ) : (
    <Box p={2}>
      <SettingsSelection />
    </Box>
  )
}

export default SettingsMobileSelection
